// import React, { useEffect, useRef, useState } from 'react';
import React, { useState } from 'react';
import PageContainer from 'src/components/container/PageContainer';
import DashboardCard from 'src/components/shared/DashboardCard';
import { Button, Grid, Snackbar} from '@mui/material';
import { Box } from '@mui/system';
// import { EditorState, convertToRaw } from 'draft-js';
// import ShowErrorMessage, { ShowSuccess } from 'src/components/CustomComponents/ShowMessages';
import { ShowSuccess } from 'src/components/CustomComponents/ShowMessages';
import ShowLoader from 'src/components/CustomComponents/ShowLoader';
// import { ReqField } from 'src/components/CustomComponents/CustomLoader';
// import { AddCircleOutlineRounded, AddCircleOutlined, CloseOutlined, CloseSharp, DeleteOutline, Female } from '@mui/icons-material';
import { useMain } from '../hooks/useMain';
import TextInputs from 'src/components/inputs/TextInputs';
import RadioInputs from 'src/components/inputs/RadioInputs';
import ClientSegmentation from './ClientSegmentation';

const initialValue = {
    clientName: "",
    clientNumber: '',
    clientEmail: '',
    address: '',
    pincode: '',
    gender: '',
}


const AddClient = () => {
    const [formData, setFormData] = useState(initialValue);
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [showLoader, setShowLoader] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value })
    }

    const { createClient } = useMain();

    const handleSubmit = async () => {
        console.log({ ...formData });
        const { clientName, pincode, gender, clientNumber, address, clientEmail } = formData;
        if (clientName.trim() === '') return setErrorMessage('Client Name is Required');
        if (pincode === '') return setErrorMessage('Pincode is Required');
        if (gender === '') return setErrorMessage('Gender is Required');
        if (clientNumber === '') return setErrorMessage('Client Number is Required');
        if (address === '') return setErrorMessage('address is Required');
        if (clientEmail === '') return setErrorMessage('clientEmail is Required');
        setShowLoader(true);

        const res = await createClient(JSON.stringify({
            ...formData,
            address: { pincode, address }
        }));

        if (res?.statusCode === 200) {
            setSuccessMessage('Client Successfully Created');
            setTimeout(() => {
                setSuccessMessage('');
            }, 7000);
            setFormData(initialValue);
            setErrorMessage('');
            setShowLoader(false);
        } else {
            setErrorMessage(res?.message);
            setTimeout(() => {
                setErrorMessage('');
            }, 7000);
            setFormData(initialValue);
            setShowLoader(false);
        }
    };
    return (
        <PageContainer title="Manage Clients" description="this is add Clients">
            <ClientSegmentation />
            <DashboardCard title="Manage New Clients">
                <Snackbar
                    open={errorMessage === '' ? false : true}
                    autoHideDuration={6000}
                    onClose={() => {
                        setErrorMessage('');
                    }}
                    severity="error"
                    message={errorMessage}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                />
                <Box style={{ marginTop: '20px' }}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={4}>
                            <TextInputs
                                title={'Client Name'}
                                name={'clientName'}
                                value={formData?.clientName}
                                handleChange={handleChange}
                                type={'text'}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <TextInputs
                                title={'Phone'}
                                name={'clientNumber'}
                                value={formData?.clientNumber}
                                handleChange={handleChange}
                                type={'number'}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <TextInputs
                                title={'Email'}
                                name={'clientEmail'}
                                value={formData?.clientEmail}
                                handleChange={handleChange}
                                type={'email'}
                            />
                        </Grid>
                    </Grid>
                </Box>

                <Box style={{ marginTop: '20px' }}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={4}>
                            <TextInputs
                                title={'Address'}
                                name={'address'}
                                value={formData?.address}
                                handleChange={handleChange}
                                type={'text'}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <TextInputs
                                title={'Pincode'}
                                name={'pincode'}
                                value={formData?.pincode}
                                handleChange={handleChange}
                                type={'number'}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <RadioInputs
                                title={'Gender'}
                                name={'gender'}
                                value={formData?.gender}
                                handleChange={handleChange}
                                options={[
                                    { title: 'M', value: 'Male' },
                                    { title: 'F', value: 'Female' }
                                ]}
                            />
                        </Grid>
                    </Grid>
                </Box>


                {showLoader && <ShowLoader value={showLoader} />}
                {/* {successMessage != '' && <ShowSuccess message={successMessage} />} */}
                {successMessage !== '' && <ShowSuccess message={successMessage} />}

                <div style={{ width: '200px', margin: '3rem auto' }}>
                    <Button
                        variant="contained"
                        fullWidth
                        color="primary"
                        target="_blank"
                        sx={{
                            background: '#6174DD'
                        }}
                        onClick={handleSubmit}
                    >
                        Manage Client
                    </Button>
                </div>
            </DashboardCard>
        </PageContainer>
    )
}

export default AddClient